import Navbar from "../../components/Navbar/Navbar";
import SongList from "../../components/SongList/SongList";

const SongListPage = () => {
  return (
    <>
      <SongList />
      <Navbar />
    </>
  );
};

export default SongListPage;
